var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilyProductIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5255 7.16816L11.4672 11.2565C11.183 11.4215 10.8255 11.4215 10.5322 11.2565L3.47388 7.16816C2.96971 6.87482 2.84138 6.18732 3.22638 5.75649C3.49221 5.45399 3.79471 5.20649 4.11554 5.03232L9.08387 2.28232C10.1472 1.68649 11.8705 1.68649 12.9339 2.28232L17.9022 5.03232C18.223 5.20649 18.5255 5.46316 18.7914 5.75649C19.158 6.18732 19.0297 6.87482 18.5255 7.16816Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4783 12.9615V19.2131C10.4783 19.9098 9.77242 20.3681 9.14909 20.0656C7.26076 19.1398 4.07992 17.4073 4.07992 17.4073C2.96159 16.7748 2.04492 15.1798 2.04492 13.869V9.13898C2.04492 8.41481 2.80576 7.95647 3.42909 8.31397L10.0199 12.1365C10.2949 12.3106 10.4783 12.6223 10.4783 12.9615Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5234 12.9615V19.2131C11.5234 19.9098 12.2293 20.3681 12.8526 20.0656C14.7409 19.1398 17.9218 17.4073 17.9218 17.4073C19.0401 16.7748 19.9568 15.1798 19.9568 13.869V9.13898C19.9568 8.41481 19.1959 7.95647 18.5726 8.31397L11.9818 12.1365C11.7068 12.3106 11.5234 12.6223 11.5234 12.9615Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyProductIcon);
export default __webpack_public_path__ + "static/media/familyProductIcon.1b54b408972fefd622edd14a35df24a9.svg";
export { ForwardRef as ReactComponent };